import { ListingType } from '@domain-group/fe-allhomes-library';
var appearanceMap = {
  [ListingType.DEVELOPMENTS_RESIDENTIAL.name]: 'NEW_DEVELOPMENT',
  [ListingType.RENTAL_COMMERCIAL.name]: 'COMMERCIAL',
  [ListingType.SALES_COMMERCIAL.name]: 'COMMERCIAL',
  [ListingType.SALES_BUSINESS.name]: 'COMMERCIAL',
  [ListingType.OFF_MARKET.name]: 'OFF_MARKET',
  [ListingType.SALES_EARLY_ACCESS.name]: 'EARLY_ACCESS'
};
export var getAppearanceFromListingType = listingType => appearanceMap[listingType] || 'RESIDENTIAL';